<template>
  <div style="display: flex; align-items: flex-start">
    <sidebar style="margin-right: 20px; max-width: 200px" />
    <el-card style="width: 100%">
      <div
        slot="header"
        class="clearfix"
      >
        <span>NTAX partnerek</span>
      </div>
      <table-filter
        v-if="config"
        :config="config"
        action="ntaxPartner/fetchAll"
      />
      <ntax-partner-list />
      <template v-if="$route.meta.showUpdateNtaxPartnerDialog">
        <ntax-partner-dialog
          :ntax-partner-id="$route.params.id"
          type="update"
        />
      </template>
    </el-card>
  </div>
</template>

<script>
  import NtaxPartnerList from '../../components/ntax/partners/List';
  import NtaxPartnerDialog from '../../components/ntax/partners/Dialog';
  import TableFilter from '../.././components/TableFilter';
  import Sidebar from '../.././components/ntax/Sidebar';

  export default {
    components: {
      NtaxPartnerList,
      TableFilter,
      Sidebar,
      NtaxPartnerDialog,
    },
    data() {
      return {
        downloadLoading: false,
        config: null,
      };
    },
    async mounted() {
      await this.setConfig();
    },
    methods: {
      async download() {
        this.downloadLoading = true;
        try {
          const txt = await axios({
            url: 'api/ntax-partners/download-partner',
            method: 'POST',
          });
          saveAs('data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,' + btoa(txt), `PARTNER.csv`);
        } catch (e) {
          console.log(e);
        }
        this.downloadLoading = false;
      },
      setConfig() {
        this.config = [
          {
            type: 'text',
            name: 'name',
            label: 'Partner név',
            defaultSearch: true
          },
          {
            type: 'text',
            name: 'ntaxCode',
            label: 'NTAX kód',
          },
          {
            type: 'text',
            name: 'webNtaxCode',
            label: 'Web NTAX kód',
          },
          {
            type: 'text',
            name: 'jobNumber',
            label: 'Munkaszám',
          },
          {
            type: 'text',
            name: 'costCentre',
            label: 'Költséghely',
          },
          {
            type: 'text',
            name: 'customName',
            label: 'Egyedi NTAX név',
          },
          {
            type: 'select',
            options: [
              {
                label: 'Igen',
                store_in_txt: '1'
              },
              {
                label: 'Nem',
                store_in_txt: '0'
              },
              {
                label: 'Nincs megadva',
                store_in_txt: null,
              },
            ],
            name: 'store_in_txt',
            label: 'PARTNER.CSV-ben szerepel',
            labelCallback: status => status.label,
            valueKey: 'store_in_txt',
          },
          {
            type: 'select',
            options: [
              {
                label: 'Vevő',
                type: 'customer'
              },
              {
                label: 'Beszállító',
                type: 'supplier'
              },
            ],
            name: 'type',
            label: 'Partner típus',
            labelCallback: option => option.label,
            valueKey: 'type',
          },
          {
            type: 'text',
            name: 'tax_number',
            label: 'Adószam',
          },
        ];
      }
    },
  };
</script>
